import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { CoachAvatar } from "@/components/CoachAvatar";
import { LogOut, Heart, Sparkles } from "lucide-react";

export const AppHeader = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <header
      className="sticky top-0 z-30 border-b border-[#2A3B32]/8 bg-[#FDFBF7]/85 backdrop-blur-xl"
      data-testid="app-header"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
        <Link to={user ? "/dashboard" : "/"} className="flex items-center gap-3" data-testid="header-logo">
          <CoachAvatar size="sm" />
          <div className="leading-tight">
            <div className="font-serif-display text-xl text-[#1C221D]">India Sadie</div>
            <div className="font-serif-display italic text-xs text-[#5C6A61]">Live the life you've always wanted.</div>
          </div>
        </Link>
        {user && (
          <div className="flex items-center gap-4">
            {user.role !== "admin" && (
              <Link
                to="/program"
                data-testid="header-program-link"
                className="hidden md:inline-flex items-center px-3 sm:px-4 py-2 rounded-full text-sm text-[#1C221D] hover:bg-[#F2EBE5] transition-colors duration-200"
              >
                <Sparkles size={14} className="sm:mr-2 text-[#E07A5F]" />
                <span className="hidden sm:inline">Discipline Reset</span>
              </Link>
            )}
            {user.role !== "admin" && (
              <Link
                to="/words"
                data-testid="header-words-link"
                className="hidden md:inline-flex items-center px-3 sm:px-4 py-2 rounded-full text-sm text-[#1C221D] hover:bg-[#F2EBE5] transition-colors duration-200"
              >
                <Heart size={14} className="sm:mr-2 text-[#E07A5F]" />
                <span className="hidden sm:inline">Words to live by</span>
              </Link>
            )}
            {user.role === "admin" && (
              <Link
                to="/coach"
                data-testid="header-coach-inbox"
                className="px-4 py-2 rounded-full bg-[#F2CC8F] text-[#2A3B32] text-sm hover:-translate-y-0.5 transition-transform duration-200"
              >
                Coach inbox
              </Link>
            )}
            <div className="hidden md:block text-right leading-tight">
              <div className="text-sm text-[#1C221D] font-medium">{user.name}</div>
              <div className="text-xs text-[#5C6A61]">{user.email}</div>
            </div>
            <button
              onClick={handleLogout}
              data-testid="logout-btn"
              className="flex items-center gap-2 whitespace-nowrap px-4 py-2 rounded-full border border-[#2A3B32]/15 text-sm text-[#1C221D] hover:bg-[#2A3B32] hover:text-[#FDFBF7] transition-colors duration-200"
            >
              <LogOut size={14} /> Sign out
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default AppHeader;
